<template>
  <v-dialog
    scrollable
    v-model="visible"
    max-width="900px"
    :fullscreen="fullscreen"
    :persistent="true"
  >
    <v-card>
      <v-toolbar flat dense>
        <v-toolbar-title class="subheading">查看</v-toolbar-title>

        <v-spacer/>

        <v-btn icon @click="fullscreen=!fullscreen">
          <v-icon>fullscreen</v-icon>
        </v-btn>
      </v-toolbar>

      <v-divider style="max-height: 1px"/>
      <v-progress-linear class="my-0" :indeterminate="true" :active="loading" height="2"/>

      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12>
              <div class="x-text-field">
                <label>合作协议名称</label>
                <div>{{item.name}}</div>
              </div>
            </v-flex>

            <v-flex xs12 sm6>
              <div class="x-text-field">
                <label>项目负责人</label>
                <div>{{item.leaderName}}</div>
              </div>
            </v-flex>

            <v-flex xs12 sm6>
              <div class="x-text-field">
                <label>负责人联系电话</label>
                <div>{{item.leaderPhone}}</div>
              </div>
            </v-flex>

            <v-flex xs12 sm6>
              <div class="x-text-field">
                <label>归属部门</label>
                <div>{{item.department? item.department.name: ''}}</div>
              </div>
            </v-flex>

            <v-flex xs12 sm6>
              <div class="x-text-field">
                <label>主管部门</label>
                <div>{{item.adminDept? item.adminDept.name: ''}}</div>
              </div>
            </v-flex>


            <v-flex xs12 sm8>
              <div class="x-text-field">
                <label>合作单位名称</label>
                <div>{{item.client}}</div>
              </div>
            </v-flex>

            <v-flex xs12 sm4>
              <div class="x-text-field">
                <label>合作单位类型</label>
                <div>{{item.clientType? item.clientType.name:''}}</div>
              </div>
            </v-flex>

            <v-flex xs12 sm6>
              <div class="x-text-field">
                <label>校章用印数</label>
                <div>{{item.instSealNum}}</div>
              </div>
            </v-flex>

            <v-flex xs12 sm6>
              <div class="x-text-field">
                <label>授权委托人章用印数</label>
                <div>{{item.prinSealNum}}</div>
              </div>
            </v-flex>

            <v-flex xs12 sm12>
              <div class="x-text-field">
                <label>协议主要内容</label>
                <div>{{item.content}}</div>
              </div>
            </v-flex>

            <v-flex xs12>
              <div class="x-text-field">
                <label>备注</label>
                <div>{{item.note}}</div>
              </div>
            </v-flex>

            <v-flex
              xs12
              v-if="item.attachments && item.attachments.length > 0"
            >
              <p class="my-1">附件列表：</p>
              <v-divider/>
              <ol>
                <li v-for="a in item.attachments" :key="a.dbid" class="pt-1">
                  <a :href="`${fileUri}/${a.dbid}`" target="_self">
                    {{a.fileName}}
                    ({{a.size | fileSize }})
                  </a>
                </li>
              </ol>
            </v-flex>

            <v-flex
              xs12
              v-if="item.extraAttachments && item.extraAttachments.length > 0"
            >
              <p class="my-1">附加附件列表：</p>
              <v-divider/>
              <ol>
                <li v-for="a in item.extraAttachments" :key="a.dbid" class="pt-1">
                  <a :href="`${fileUri}/${a.dbid}`" target="_self">
                    {{a.fileName}}
                    ({{a.size | fileSize }})
                  </a>
                </li>
              </ol>
            </v-flex>

          </v-layout>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer/>
        <v-btn color="primary" @click.native="visible=false">关闭</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  import mixin from '@/mixin'

  const baseUri = '/api/agmt/agreement';

  export default {
    mixins: [mixin.view(baseUri)],

    data() {
      return {
        fileUri: '/api/agmt/file',

        item: {},
      }
    },
  }
</script>
